// extracted by mini-css-extract-plugin
module.exports = {"label":"Input_label__3sEkI","error":"Input_error__HOCjV","input":"Input_input__3rPb3","textarea":"Input_textarea__CV6YU"};